import React from "react"
import styled from "styled-components"

import {FormattedMessage} from "@irati/utils/lang"

import {Wrapper, TrophyIcon, Paragraph} from "./styled/Feed"

const StyledWrapper = styled(Wrapper)`
  box-shadow: none;
  border: none;
`

const EmptyTrophies = () => {
  return (
    <StyledWrapper>
      <TrophyIcon />
      <Paragraph>
        <FormattedMessage id="recognition.account.trophies.empty" />
      </Paragraph>
    </StyledWrapper>
  )
}

export default EmptyTrophies
